
 
export default {

    state: {
    userDetail: {},
    userRole: "",
    isAllUsers: false,
    isCMUsers:false,
    isAdmin:false,
    isSubmitting: false,
    },
  
    mutations: {
  
      // Mutation to set the ID
  
      setUserDetail(state, userDetail ) {
  
        state.userDetail = userDetail;
        
  
      },
      setUserRole(state, userRole ) {
  
        state.userRole = userRole;
        
  
      },
      setIsAllUsers(state, isAllUsers ) {
  
        state.isAllUsers = isAllUsers;
        
      },

      setIsCMUsers(state, isCMUsers ) {
  
        state.isCMUsers = isCMUsers;
        
      },
      
      setIsAdmin(state, isAdmin ) {
  
        state.isAdmin = isAdmin;
        
      },
      setIsSubmitting(state, isSubmitting ) {
  
        state.isSubmitting = isSubmitting;
        
      },
     
  
    },
  
    actions: {
  
      // Action to commit the mutation
  
      updateUserDetail({ commit }, userDetail) {
  
        commit('setUserDetail', userDetail);
  
      },
      updateUserRole({ commit }, userRole) {
  
        commit('setUserRole', userRole);
  
      },
      updateIsAllUsers({ commit }, isAllUsers) {
  
        commit('setIsAllUsers', isAllUsers);
  
      },
      updateIsCMUsers({ commit }, isCMUsers) {
  
        commit('setIsCMUsers', isCMUsers);
  
      },
      updateIsAdmin({ commit }, isAdmin) {
  
        commit('setIsAdmin', isAdmin);
  
      },
      updateIsSubmitting({ commit }, isSubmitting) {
  
        commit('setIsSubmitting', isSubmitting);
  
      },
     
  
    },
  
    getters: {
  
      
  
      getUserDetail(state) {
  
        return state.userDetail;
  
      },
      getUserRole(state) {
  
        return state.userRole;
  
      },
      getIsAllUsers(state) {
  
        return state.isAllUsers;
  
      },
      getIsCMUsers(state) {
  
        return state.isCMUsers;
  
      },
      getIsAdmin(state) {
  
        return state.isAdmin;
  
      },
      getIsSubmitting(state) {
  
        return state.isSubmitting;
  
      },
     
  
    },
  
  };
  
   